module.exports = __webpack_public_path__ + "LANDROVER-logo.png";